<template>
  <div class="login">
    <!--  -->
    <div class="logo"></div>
    <div class="login-box">
      <div class="top">
        <p class="title">园区账号登录</p>
      </div>
      <el-alert
        class="error-text"
        v-show="isError"
        :title="errorMsg"
        type="error"
        center
        show-icon
        :closable="false"
      ></el-alert>

      <el-form
        ref="paramsFormRef"
        :model="paramsForm"
        :rules="paramsRules"
        class="login-form"
        @keydown.enter.native="isReadProtocol ? firstlogin() : null"
      >
        <el-form-item prop="account" label="账号">
          <el-input
            v-model.trim="paramsForm.account"
            prefix-icon="el-icon-mobile-phone"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password" label="密码">
          <el-input
            v-model="paramsForm.password"
            prefix-icon="el-icon-lock"
            placeholder="请输入密码"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item prop="verifyCode" label="验证码">
          <div style="display: flex; width: 100%">
            <el-input
              v-model="paramsForm.verifyCode"
              prefix-icon="el-icon-key"
              placeholder="请输入验证码"
            >
            </el-input>
            <img :src="vCodeImg" alt="" class="vCode" @click="getVerifyCode()" />
          </div>
        </el-form-item>
      </el-form>

      <div class="tools">
        <el-checkbox v-model="isRemenmberMe">记住账号和密码</el-checkbox>
        <span
          style="color: #fff; font-size: 12px; cursor: pointer"
          @click="$router.push('/register/findpassword')"
          >忘记密码?</span
        >
      </div>

      <el-button
        type="primary"
        :class="isReadProtocol ? 'login-btn' : 'disable-btn'"
        @click="firstlogin"
        :loading="btnLoading"
        >登录</el-button
      >
      <el-checkbox v-model="isReadProtocol" class="toolsLabel">
        <span style="color: #fff; cursor: default" @click.prevent>已阅读并同意</span>
        <span style="color: #409dff" @click.prevent="handleClickProtocol('Protocol')"
          >《平台用户使用协议》</span
        >
      </el-checkbox>
      <!--  <div class="qr_box">
        <div class="phoneicon" @click="handleOpenQRDialog">
          <img src="~assets/images/phone.png" />
          <span class="qr_text">APP下载</span>
        </div>
        <div class="register-text">
          <span style="color:#90939B;margin-right:5px">还没有账号?</span>
          <span @click="$router.push('/register')">立即注册>></span>
        </div>
      </div> -->
    </div>
    <div class="qr5_box" @click="handleOpenQRDialog">
      <img src="~assets/images/erweima.png" />
    </div>
    <!-- 通知公告框 -->
    <div class="notice-box" v-if="config.notice_content">
      <h2 class="notice-title">重要通知：</h2>
      <p class="notice-content" v-html="config.notice_content"></p>
    </div>
    <div class="footer">蜀ICP备2024045053号-1</div>
    <!-- 二维码弹窗 -->
    <el-dialog title="请扫描二维码下载APP" :visible.sync="QrDialogVisible" width="370px">
      <div class="qr-wrapper" v-if="QrDialogVisible">
        <div class="qr-box-ehs">
          <!-- <p class="qr-title">EHS云管家系统</p> -->
          <div class="qr-code" id="qr-code" style="margin: auto">
            <img class="cloud" src="~assets/images/cloud.png" />

            <div class="code-footer"></div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 提示用户升级弹窗 -->
    <el-dialog title="浏览器版本过低" :visible.sync="tipsDialogVisible" width="670px">
      <el-alert
        title="为了更好的使用体验，建议使用最新版本"
        type="warning"
        show-icon
        :closable="false"
      ></el-alert>
      <p>
        请检查新版本或进入官网下载最新版本，官方网址：
        <a href="http://browser.360.cn/">点击进入</a>
      </p>
    </el-dialog>
    <!-- 手机短信验证 -->
    <el-dialog
      title="短信验证"
      :before-close="handleClose"
      :visible.sync="phoneDialogVisible"
      width="458px"
    >
      <div class="smsbox">
        <el-input
          v-model.trim="smsCode"
          prefix-icon="el-icon-mobile-phone"
          placeholder="请输入6位短信验证码"
        ></el-input>
        <div @click="getSmsCode" class="smsCode">{{ smsText }}</div>
      </div>
      <el-button type="primary" class="login-btn" @click="handleLogin" :loading="btnLoading"
        >登录</el-button
      >
      <!-- <div style="text-align: center;">
        <el-button
          style="background-color: #fff;color: #90939B;margin: 0 auto;"
          type="primary"
          round
          @click="handleClose()"
          :loading="btnLoading"
          >取消</el-button
        >
      </div> -->
    </el-dialog>
    <edit :editShow="editShow" @nextFun="getUserInfoData" ref="editDia"> </edit>
  </div>
</template>

<script>
import getPath from '../../../utils/getPath.js';
import config from '@/config';
import commonApi from '@/api/common.js';
import loginAPi from 'api/login.js';
import { mapGetters, mapActions } from 'vuex';
import store from 'utils/store.js';
import QRCode from 'qrcodejs2';
import CryptoJS from 'crypto-js';
import edit from './editPass.vue';
export default {
  components: { edit },
  data() {
    const validatePhone = (rule, value, callback) => {
      const phoneReg = /^(?:(?:\+|00)86)?1\d{10}$/;
      if (value.length === 0) {
        callback(new Error('请输入手机号'));
      }
      // else if (!phoneReg.test(value)) {
      //   callback(new Error('请输入正确的手机号'));
      // }
      else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error('请输入密码'));
      } else if (!/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{8,16}$/.test(value)) {
        callback(new Error('8~16位字母、数字或特殊字符组合'));
      }
      // else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@#$%&*]).{8,}$|^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d).{8,}$|^(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%&*]).{8,}$|^(?=.*[a-z])(?=.*\\d)(?=.*[@#$%&*]).{8,}$|^(?=.*[A-Z])(?=.*\\d)(?=.*[@#$%&*]).{8,}$/.test(value)) {
      //   callback(new Error('8~16位包含大小写字母、数字或特殊字符组合'));
      // }
      else {
        callback();
      }
    };
    const validateVerifyCode = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error('请输入验证码'));
      } else {
        callback();
      }
    };
    return {
      config,
      platformName: '智慧园区环保管理平台',
      isError: false,
      errorMsg: '',
      isRemenmberMe: true,
      isReadProtocol: true,
      btnLoading: false,
      paramsForm: {
        account: '',
        password: '',
        verifyCode: ''
      },
      paramsRules: {
        account: [{ trigger: 'blur', validator: validatePhone }],
        password: [{ trigger: 'blur', validator: validatePassword }],
        verifyCode: [{ trigger: 'blur', validator: validateVerifyCode }]
      },
      QrDialogVisible: false,
      applistAddress: '',
      ehsAPPAdress: '',
      yanbianIOS: 'https://itunes.apple.com/app/id1504792074',
      yanbianAndroid:
        'https://ybfzgroup.obs.scmcc.com.cn/document/2020/10/14/1316228222031470594.apk',
      tipsDialogVisible: false,
      orgId: '',
      tenantInfo: {
        tenantId: '',
        tenantName: ''
      },
      vCodeImg: '',
      phoneDialogVisible: false,
      smsCode: '',
      smsText: '获取验证码',
      timeSms: null,
      verifyCode: '',
      editShow: false
    };
  },
  computed: {
    ...mapGetters(['token', 'userInfo'])
  },
  created() {
    //保持登陆状态，90天不登陆
    /* if (store.get('token')) {
      if (store.get('tokenTime')) {
        let tokenTime = store.get('tokenTime');
        let a = new Date().getTime();
        let time = a - tokenTime;
        if (time < 1000 * 60 * 60 * 24 * 90) {
          this.getUserInfoData();
        } else {
          window.localStorage.removeItem('token');
          window.localStorage.removeItem('tokenTime');
        }
      }
    } */
    this.isNewestBrowserByUserActivationProperty();
    this.getTitle();
    // this.getAppAddressData();
    // 获取host，开发环境跳转子系统用
    this.myHostName = window.location.hostname;
    // 记住账号和密码，从本地读取
    const params = store.get('paramsForm');
    if (params) {
      this.paramsForm = params;
      this.$set(this.paramsForm, 'verifyCode', '');
    }

    if (process.env.NODE_ENV === 'development') {
      this.applistAddress = `http://192.168.0.162:8090/#/applist`;
    } else {
      this.applistAddress = 'https://cgsmartpark.com:8091/#/applist';
    }
  },
  mounted() {},
  methods: {
    ...mapActions(['login', 'getUserInfo']),
    getTitle() {
      commonApi
        .getDictType('platform_config')
        .then(res => {
          if (res.data.code !== 200) {
            return;
          }
          const platformInfoList = res.data.data;
          platformInfoList.forEach(item => {
            if (item.code === 'platform_name') {
              this.platformName = item.value;
            }
          });
          this.getVerifyCode();
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 检测谷歌内核浏览器是否需要升级
    isNewestBrowserByUserActivationProperty() {
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.indexOf('chrome') > 1) {
        if (window.navigator.userActivation) {
          this.tipsDialogVisible = false;
        } else {
          this.tipsDialogVisible = true;
        }
      } else {
        this.tipsDialogVisible = false;
      }
    },
    handleLogin() {
      if (!this.isReadProtocol) {
        this.isError = true;
        this.errorMsg =
          '请阅读并接受《平台用户使用协议》所有条款，否则您将无权使用本平台相关服务。';
        this.btnLoading = false;
        return;
      }
      this.$refs.paramsFormRef.validate(valid => {
        if (this.paramsForm.account !== 'admin') {
          if (!valid) {
            return;
          }
        } else {
          if (!this.smsCode && this.phoneDialogVisible) {
            return;
          }
        }
        this.btnLoading = true;
        const params = JSON.parse(JSON.stringify(this.paramsForm));
        params.smsCode = this.smsCode || undefined;
        params.password = this.descWord(params.password);
        // console.log(params);
        // 登录
        this.login(params)
          .then(res => {
            // 如果登录报错，错误提示
            if (!this.isLoginSuccess(res.data.code, res.data.message)) {
              return;
            }
            if (typeof res.data.data === 'boolean') {
              this.phoneDialogVisible = true;
              // this.handleLogin();
              return;
            }
            // 加密后保存到session中，供跳转时传参使用
            const encPassword = window.btoa(params.password); // 字符串 转换 base-64
            store.setSession('encParams', {
              account: params.account,
              pwd: encPassword
            });

            // 登录成功后，记住账号和密码
            if (this.isRemenmberMe) {
              store.set('paramsForm', {
                account: this.paramsForm.account,
                password: this.paramsForm.password
              });
            } else {
              store.remove('paramsForm');
            }
            loginAPi
              .needChangePwd()
              .then(res => {
                if (!res.data.data) {
                  this.getUserInfoData();
                } else {
                  this.$refs.editDia.init();
                }
              })
              .catch(err => {});
            // 获取用户信息
          })
          .catch(error => {
            this.btnLoading = false;
          })
          .finally(() => {
            this.btnLoading = false;
            if (!this.phoneDialogVisible) {
              this.getVerifyCode();
            }
          });
      });
    },
    // 登录错误状态码判断
    isLoginSuccess(status, message) {
      if (status === 1011002) {
        this.isError = true;
        this.errorMsg = '账号或密码错误，请重新输入！';
        this.btnLoading = false;
        return false;
      } else if (status === 1011007) {
        this.isError = true;
        this.errorMsg = '当前账号已被冻结，请联系管理员';
        this.btnLoading = false;
        return false;
      } else if (status === 10110014) {
        this.isError = true;
        this.errorMsg = '当前账号认证失败，请联系管理员';
        this.btnLoading = false;
        return false;
      } else if (status === 1011008) {
        this.isError = true;
        this.errorMsg = '当前账号未认证，请联系管理员';
        this.btnLoading = false;
        return false;
      } else if (status === 10110015) {
        this.isError = true;
        this.errorMsg = '当前账号不存在，请先注册账号';
        this.btnLoading = false;
        return false;
      } else if (status !== 200) {
        this.isError = true;
        this.errorMsg = message;
        this.btnLoading = false;
        return false;
      } else {
        return true;
      }
    },
    // 登录成功，获取用户信息
    getUserInfoData() {
      this.getUserInfo().then(res => {
        // debugger;
        const appList = res.data.data.appList;
        this.orgId = appList[0].orgId;
        this.tenantInfo.tenantId = appList[0].orgId;
        this.tenantInfo.tenantName = appList[0].orgName;
        // 该角色无管理的子系统
        if (appList.length === 0) {
          this.isError = true;
          this.errorMsg = '当前账户无系统权限！请联系管理员';
          this.btnLoading = false;
          return;
        }
        this.btnLoading = false;
        // 平台超管，跳转平台首页
        if (this.userInfo.adminType === 1) {
          if (this.userInfo.account == atob('MTUyMDAwMDAwMDE=')) {
            this.$router.push('/home/dictionary');
          } else if (this.userInfo.account == atob('MTUyMDAwMDAwMDI=')) {
            this.$router.push('/home/access');
          } else {
            this.$router.push('/home');
          }
          this.$message({
            message: '登录成功',
            type: 'success'
          });
          return;
        }
        // 其他角色 判断是否仅一个子系统
        let appTotalList = [];
        appList.forEach(item => {
          item.appInfoList.forEach(subItem => {
            appTotalList.push(subItem);
          });
        });

        if (appTotalList.length === 1) {
          // 仅管理一个子系统
          const appItem = appTotalList[0];
          // 标志仅管理一个子系统 全过程判断用
          appItem.systemLength = 1;

          switch (appItem.status) {
            // 该子系统为启用状态 status === 0
            case 0:
              // 跳转该子系统地址 address
              this.handleJumpApp(appItem);
              break;
            // 该子系统为冻结状态 status === 1 跳转子系统选择页
            case 1:
              this.$router.push('/register/systemselect');
              this.$message({
                message: '登录成功',
                type: 'success'
              });
              break;
          }
        } else {
          // 管理多个子系统
          this.$router.push('/register/systemselect');
          this.$message({
            message: '登录成功',
            type: 'success'
          });
          return;
        }
        // this.$router.push('/register/systemselect');
        // this.$message({
        //   message: '登录成功',
        //   type: 'success'
        // });
        // return;
      });
    },
    // 子系统跳转 appInfo: 当前选择的子系统
    handleJumpApp(appInfo) {
      const { token, orgId, tenantInfo } = this;
      const { account, pwd } = store.getSession('encParams'); // 针对 全过程（外部）系统
      // 候选参数
      const candidate = { appInfo, token, orgId, account, pwd, tenantInfo };
      const path = getPath(appInfo, candidate);
      window.location.href = path;
    },
    // 生成二维码
    setQRCode(address, id) {
      let qrcode = new QRCode(id, {
        width: 200, // 设置宽度，单位像素
        height: 200, // 设置高度，单位像素
        text: address, // 设置二维码内容或跳转地址
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.M
      });
    },
    // 点击下载app
    handleOpenQRDialog() {
      this.QrDialogVisible = true;
      this.$nextTick(() => {
        this.setQRCode(this.applistAddress, 'qr-code');
        // this.setQRCode(this.yanbianIOS, 'qr-code-yb-ios');
        // this.setQRCode(this.yanbianAndroid, 'qr-code-yb-android');
      });
    },
    // 获取二维码地址
    getAppAddressData() {
      loginAPi
        .getAppAddress({
          appCode: 'ehs'
        })
        .then(res => {
          if (res.data.code === 200) {
            this.ehsAPPAdress = res.data.data.android;
          }
          // else {
          //   this.$message.error(res.data.message);
          // }
        });
    },
    // 点击协议
    handleClickProtocol(name) {
      const { href } = this.$router.resolve({ name });
      window.open(href);
    },
    offFour(index) {
      this.activeClass1 = index;
    },
    getVerifyCode() {
      loginAPi
        .getVerifyCode()
        .then(res => {
          this.vCodeImg = 'data:image/jpg;base64,' + res.data.data;
        })
        .catch(err => {});
    },
    async firstlogin() {
      // let res = await loginAPi.firstlogin({ account: this.paramsForm.account });
      this.handleLogin();
    },
    getSmsCode() {
      if (!this.timeSms) {
        loginAPi
          .sendSmsCode({ account: this.paramsForm.account })
          .then(res => {
            this.smsText = 60;
            this.timeSms = setInterval(() => {
              this.smsText -= 1;
              if (this.smsText === 1) {
                this.smsText = '获取验证码';
                clearInterval(this.timeSms);
                this.timeSms = null;
              }
            }, 1000);
          })
          .catch(err => {});
      }
    },
    handleClose() {
      this.smsCode = '';
      this.phoneDialogVisible = false;
      this.getVerifyCode();
    },
    descWord(str) {
      var aseKey = 'hjiuhjsd'; //定制秘钥，长度必须为： 8/16/32位
      var message = str; //加密 DES/AES切换只需要修改 CryptoJS.AES <=> CryptoJS.DES
      var encrypt = CryptoJS.DES.encrypt(message, CryptoJS.enc.Utf8.parse(aseKey), {
        iv: CryptoJS.enc.Utf8.parse('hjiuhjsd'),
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      // console.log(encrypt.toString());
      return encrypt.toString();
      //解密
      /* var decrypt = CryptoJS.DES.decrypt(encrypt, CryptoJS.enc.Utf8.parse(aseKey), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }).toString(CryptoJS.enc.Utf8);
      console.log(decrypt); */
    }
  },
  beforeDestroy() {
    if (this.timeSms) {
      clearInterval(this.timeSms);
    }
  }
};
</script>

<style lang="less" scoped>
// /deep/ input.el-input__inner:focus {
//   box-shadow: #59bbff 0px 0px 6px;
//   border-color: #59bbff;
// }
.login {
  position: relative;
  width: 100%;
  height: 100%;
  background: url('~assets/images/20240508165609.png') no-repeat;
  background-size: cover;
}
.logo {
  position: absolute;
  width: 558px;
  height: 66px;
  top: 28px;
  left: 40px;
  background: url('~assets/images/logo_fushun.png') no-repeat;
}
.people {
  width: 772px;
  height: 436px;
  background: url('~assets/images/login-people.png') no-repeat;
  background-size: cover;
  position: absolute;
  top: 20%;
  left: 12%;
}

.login-box {
  z-index: 10;
  box-sizing: border-box;
  overflow: hidden;
  position: absolute;
  top: 18vh;
  right: 204px;
  width: 474px;
  // height: 625px;
  padding: 32px;
  background-color: rgba(4, 19, 48, 0.6);
  box-shadow: 0px 3px 6px 0px rgba(6, 12, 31, 0.16);
  // opacity: 0.5;
  border-radius: 8px;
  backdrop-filter: blur(8px);
  .top {
    height: 32px;
    display: flex;
    justify-content: space-between;
    line-height: 32px;
    margin-bottom: 54px;

    p {
      padding: 0;
      margin: 0;
    }

    .title {
      font-size: 24px;
      color: #fff;
    }

    .apply {
      width: 100px;
      height: 32px;
      position: absolute;
      top: 32px;
      right: -16px;
      background: #409dff;
      box-shadow: 0px 3px 6px rgba(64, 157, 255, 0.3);
      opacity: 1;
      border-radius: 16px;
      color: #fff;
      font-size: 12px;
      text-align: center;
      line-height: 32px;
      cursor: pointer;
    }
  }

  .error-text {
    position: absolute;
    top: 70px;
    left: 0;
    backdrop-filter: blur(8px);
    background-color: rgba(0, 0, 0, 0.1);
  }

  .tools {
    display: flex;
    justify-content: space-between;
    margin-bottom: 50px;
    line-height: 20px;
    margin-top: -5px;
    /deep/ .el-checkbox__label {
      font-size: 12px;
    }
    /deep/ .el-checkbox {
      color: #fff;
    }
  }
  .toolsLabel {
    /deep/ .el-checkbox__label {
      font-size: 12px;
    }
  }

  .disable-btn {
    width: 100%;
    border-radius: 20px;
    margin-bottom: 16px;
    box-shadow: 0px 3px 6px rgba(64, 157, 255, 0.3);
    background: none;
    background-color: #dddddd;
    border: 1px solid transparent;
    transition: all ease-in-out 0.2;
  }

  .register-text {
    padding: 0;
    margin: 0;
    font-size: 14px;
    text-align: right;
    line-height: 14px;
    color: #90939b;

    span {
      color: #409dff;
      cursor: pointer;
    }
  }
}

.notice-box {
  box-sizing: border-box;
  overflow: hidden;
  position: absolute;
  top: calc(~'15% + 549px');
  right: 250px;
  width: 474px;
  height: 177px;
  padding: 16px 28px;
  background: #ffffff;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  opacity: 0.9;
  border-radius: 4px;

  .notice-title {
    margin: 0;
    margin-bottom: 10px;
    height: 20px;
    font-size: 16px;
    font-weight: bold;
    line-height: 20px;
    color: #333333;
    opacity: 1;
  }

  .notice-content {
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #666666;
    letter-spacing: 0.3px;
    line-height: 24px;
    opacity: 1;
  }
}

.footer {
  z-index: 99;
  position: absolute;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
  color: #f3f6fe;
  a {
    text-decoration: none;
    color: #f3f6fe;
    font-size: 12px;
  }
}

.qr_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #e3f2ff;
  position: absolute;
  left: 0;
  height: 44px;
  padding: 0 32px;
  width: 410px;
  .phoneicon {
    cursor: pointer;
    display: flex;
    align-items: center;
  }
  .qr_text {
    margin-left: 10px;
    font-size: 16px;
    color: #1790fb;
    padding-bottom: 5px;
    border-bottom: 1px solid #1790fb;
  }
}

.qr-wrapper {
  display: flex;
  justify-content: space-between;

  .qr-box-ehs {
    flex: 1;
    height: 240px;
    position: relative;
    box-sizing: border-box;

    .qr-code {
      position: relative;
      // margin: 0 auto;
      width: 200px;
      height: 200px;
      padding: 21px 23px 23px 21px;

      .cloud {
        width: 50px;
        height: 50px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 30px;
        height: 30px;
        border-left: 2px solid #409dff;
        border-top: 2px solid #409dff;
      }
      &::after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        width: 30px;
        height: 30px;
        border-right: 2px solid #409dff;
        border-top: 2px solid #409dff;
      }

      .code-footer {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;

        &::before {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 30px;
          height: 30px;
          border-left: 2px solid #409dff;
          border-bottom: 2px solid #409dff;
        }
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          right: 0;
          width: 30px;
          height: 30px;
          border-right: 2px solid #409dff;
          border-bottom: 2px solid #409dff;
        }
      }
    }
  }

  .qr-box-yanbian {
    flex: 2;
    height: 255px;
  }

  .qr-title {
    margin: 0;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 16px;
    margin-bottom: 25px;
    color: #666666;
  }

  .qr-list {
    display: flex;
    justify-content: center;
  }
}
.roleLogin {
  font-size: 18px;
  font-weight: 400;
  color: #303133;
}
.system {
  margin-top: 10px;
  font-size: 24px;
  font-weight: bold;
  color: #1790fb;
}
.choiceRole {
  font-size: 24px;
  font-weight: 400;
  color: #303133;
  margin-top: 40px;
}
.login-form {
  /deep/ .el-form-item {
    margin-bottom: 18px;
  }
  /deep/ .el-form-item__label {
    color: #fff !important;
  }
  /deep/ .el-input__inner {
    color: #fff;
    background-color: rgba(49, 74, 110, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.4);
  }
}
.qr5_box {
  position: absolute;
  bottom: 40px;
  right: 32px;
  cursor: pointer;
  opacity: 0.5;
}
.qr5_box:hover {
  opacity: 1;
}
.vCode {
  width: 104px;
  height: 40px;
  min-width: 104px;
  margin-left: 6px;
}
.smsCode {
  width: 112px;
  height: 40px;
  background: rgba(#e5f3fe);
  color: #038ef4;
  line-height: 40px;
  text-align: center;
  margin-left: 6px;
  cursor: pointer;
}
.login-btn {
  width: 100%;
  background: linear-gradient(90deg, #4189fd 0%, #409dff 100%);
  box-shadow: 0px 3px 6px rgba(64, 157, 255, 0.3);
  opacity: 1;
  border-radius: 20px;
  margin-bottom: 16px;
  transition: all ease-in-out 0.2;
}
.smsbox {
  display: flex;
  margin: 0 13px;
  margin-top: 20px;
  margin-bottom: 40px;
}
</style>
